import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';  
import TopBar from './components/TopBar';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  // Desktop par default open, Mobile par default close
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 992);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 992;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(true);
      else setSidebarOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`admin-layout ${sidebarOpen ? '' : 'sidebar-collapsed'}`}>
      {/* Mobile Backdrop */}
      {isMobile && sidebarOpen && (
        <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)}></div>
      )}

      <Sidebar 
        sidebarOpen={sidebarOpen} 
        closeSidebar={() => isMobile && setSidebarOpen(false)} 
      />
      
      <div className="admin-main">
        <TopBar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <div className="admin-content">{children}</div>
      </div>
    </div>
  );
};

export default AdminLayout;